export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14438.5c39550e.jpg";